import script from "./UserSettingsEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSettingsEditor.vue?vue&type=script&setup=true&lang=ts"

import "./UserSettingsEditor.vue?vue&type=style&index=0&id=8b7c45e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b7c45e6"]])

export default __exports__